module.exports = __webpack_public_path__ + "img/ennetix-xvisor-overview2.9db99ade.png";